module.exports = __webpack_public_path__ + "img/sl.5a0703e0.svg";